import { render, staticRenderFns } from "./lp-en-primeur-purchase-2.vue?vue&type=template&id=f2a97d72&scoped=true"
import script from "./lp-en-primeur-purchase-2.vue?vue&type=script&lang=js"
export * from "./lp-en-primeur-purchase-2.vue?vue&type=script&lang=js"
import style0 from "./lp-en-primeur-purchase-2.vue?vue&type=style&index=0&id=f2a97d72&prod&scoped=true&lang=css"
import style1 from "./lp-en-primeur-purchase-2.vue?vue&type=style&index=1&id=f2a97d72&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a97d72",
  null
  
)

export default component.exports